// extracted by mini-css-extract-plugin
export default {"seedGate":"useSeededEditForm_seedGate__sIXXZ"};